var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4062 10.9688C15.8021 11.1354 16 11.4375 16 11.875C16 11.9583 15.9896 12.0312 15.9688 12.0938L15.25 15.25C15.2083 15.4583 15.0938 15.6354 14.9062 15.7812C14.7396 15.9271 14.5417 16 14.3125 16H14.2812C12.3646 16 10.5208 15.625 8.75 14.875C6.97917 14.125 5.45833 13.1146 4.1875 11.8438C2.91667 10.5521 1.89583 9.03125 1.125 7.28125C0.375 5.51042 0 3.65625 0 1.71875V1.6875C0 1.45833 0.0729167 1.26042 0.21875 1.09375C0.364583 0.90625 0.541667 0.791667 0.75 0.75L3.90625 0.03125C3.98958 0.0104167 4.0625 0 4.125 0C4.5625 0 4.86458 0.197917 5.03125 0.59375L6.46875 3.96875C6.53125 4.09375 6.5625 4.22917 6.5625 4.375C6.5625 4.66667 6.4375 4.91667 6.1875 5.125L4.5 6.5C5.60417 8.72917 7.27083 10.3958 9.5 11.5L10.875 9.8125C11.0833 9.5625 11.3333 9.4375 11.625 9.4375C11.7708 9.4375 11.9062 9.46875 12.0312 9.53125L15.4062 10.9688ZM14.2812 15L15 11.875L11.625 10.4375L9.78125 12.7188C8.15625 11.9688 6.85417 11.1042 5.875 10.125C4.89583 9.14583 4.03125 7.84375 3.28125 6.21875L5.5625 4.375L4.125 1L1 1.71875C1 4.13542 1.59375 6.36458 2.78125 8.40625C3.96875 10.4271 5.58333 12.0312 7.625 13.2188C9.66667 14.4062 11.8854 15 14.2812 15Z",
    fill: "#31BF5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbol);
export default __webpack_public_path__ + "static/media/Symbol.68b1c51287239a820c0732d8bb86362d.svg";
export { ForwardRef as ReactComponent };